import {styled} from "@mui/material/styles"

export const FavouritesContainer = styled("div")(({theme}) => {
    return {
        cursor: "pointer",
        height: "2.25rem",
        width: "2.25rem",
        position: "absolute",
        bottom: "1.125rem",
        right: "0.625rem",
        border: theme.colours.utilities.dividerDark,
        background: "#fff",
        borderRadius: "50%",
        zIndex: 100,
    }
})
export default FavouritesContainer
